import { render, staticRenderFns } from "./OrderSection.vue?vue&type=template&id=aae472aa&scoped=true&"
import script from "./OrderSection.vue?vue&type=script&lang=js&"
export * from "./OrderSection.vue?vue&type=script&lang=js&"
import style0 from "./OrderSection.vue?vue&type=style&index=0&id=aae472aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae472aa",
  null
  
)

export default component.exports